import { whenever } from '@vueuse/core'
import { onMounted, computed } from 'vue'

import { SortName } from '@scayle/storefront-nuxt'
import { useNuxtApp } from '#app/nuxt'

import useExperiments from '~/composables/useExperiments'
import useNewPlp from '../../composables/plp/useNewPlp'
import useSorting from '../../composables/useSorting'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'

type PlpState = ReturnType<typeof useNewPlp>

export default (plp?: PlpState) => {
  const { $device } = useNuxtApp()
  const { selectedSort } = useSorting()
  const { showOdoscopePlp: showOdoscopeProducts, hasCustomSort } =
    plp ?? useNewPlp()
  const { showOdoscopePlp } = useExperiments()
  const { trackOdoscopeControlGroup } = useTrackingEvents()

  const showFallbackProducts = computed(() => !showOdoscopeProducts.value)

  const trackingToken = computed(() => {
    if (selectedSort.value?.name === SortName.TOPSELLER) {
      return showOdoscopePlp.value ? 'product' : 'controlSorting'
    }

    return 'sorting'
  })

  onMounted(() => {
    if ($device.isCrawler) {
      return
    }

    whenever(
      showFallbackProducts,
      () => {
        // ECOM-2669: curated (manual-sort) categories are deterministically
        // served by SAPI and were never Odoscope-served — don't count them as
        // Odoscope control-group events, which would otherwise attribute a
        // treatment token ('product') to a page Odoscope never delivered.
        if (hasCustomSort.value) {
          return
        }

        trackOdoscopeControlGroup(trackingToken.value)
      },
      { immediate: true },
    )
  })
}
